import { AxiosRequestConfig, RawAxiosRequestHeaders, AxiosResponse, isAxiosError } from 'axios'
import { parseErrorResponse } from './shared'
import { api } from '../../index'

export const deleteRequest = async <TResponse, TPayload = undefined>(
  url: string,
  payload?: TPayload
): Promise<TResponse & { statusCode?: number }> => {
  const headers: RawAxiosRequestHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }

  const config: AxiosRequestConfig = {
    method: 'DELETE',
    url: url,
    headers: headers,
    data: payload
  }

  try {
    const response: AxiosResponse = await api.request(config)

    // If axios doesn't respond with a 2xx status code, it will result in an error in the catch block
    if (response.data) {
      return { ...response.data, statusCode: response.status }
    } else {
      // This is when we are getting success codes but the API is really giving us some error
      // message. This needs to be fixed to send a proper status code.
      throw new Error(parseErrorResponse(response.data))
    }
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response?.status === 401) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return {
          success: false,
          message: 'You are unauthorized to access this resource. Please login again.',
          statusCode: error.response.status
        }
      }

      const errorMessage =
        error.response?.data?.message ||
        error.response?.data?.error ||
        (error.response?.data?.errors || []).join(', ') ||
        'Unknown Error'

      const errors = error.response?.data?.errors

      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return {
        success: false,
        message: errorMessage,
        errors: errors,
        statusCode: error.response?.status
      }
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return {
      success: false,
      message: 'Unknown Error',
      statusCode: 404
    }
  }
}
